export default {"src":"/_next/static/media/logo__chrono-white.c938dd3d.svg","height":160,"width":922,"blurWidth":0,"blurHeight":0};